import React from 'react';

import { HomeGroupLayout, InviteFreeGroupUserForm } from 'components';

/**
 * free group 邀請成員頁面
 */

export const InviteFreeGroupUserPage = () => {
  return (
    <HomeGroupLayout>
      <InviteFreeGroupUserForm />
    </HomeGroupLayout>);
};

